import React from 'react';
import PropTypes from 'prop-types';
import StatBar from 'components/StatBar';
import StatBarItem from 'components/StatBar/StatBarItem';
import { CONTACT_ERRORS } from 'constants/contact';
import { isEmpty, get } from 'lodash';

const ContactStats = (props) => {
  const { contacts, validContacts } = props;

  const blacklisted = contacts.filter(contact => !isEmpty(contact.errors.filter(e =>
    e.error_type === CONTACT_ERRORS.BLACKLISTED))).length;
  const bounced = contacts.filter(contact => !isEmpty(contact.errors.filter(e =>
    e.error_type === CONTACT_ERRORS.BOUNCED))).length;
  const replied = contacts.filter(contact => get(contact, 'replies', []).length).length;
  const optouts = contacts.filter(contact =>
    contact.status_unsubscribed_date || contact.status_not_interested_date).length + blacklisted;

  return (
    <StatBar>
      <StatBarItem label="Total attempted" value={contacts !== null ? contacts.length : '-'} />
      <StatBarItem label="Total available to add" value={validContacts} />
      <StatBarItem label="Opted out" value={optouts} />
      <StatBarItem label="Bounced" value={bounced} />
      <StatBarItem label="Don't contact" value={blacklisted} />
      <StatBarItem label="Replied" value={replied} />
    </StatBar>
  );
};

ContactStats.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.shape({
    length: PropTypes.number,
  })),
  validContacts: PropTypes.number,
};

ContactStats.defaultProps = {
  contacts: [],
  validContacts: 0,
};


export default ContactStats;
